import React from "react"
import NavbarTop from "./NavbarTop"
import NavbarDown from "./NavbarDown"
const Navigation = () => {
    return (
        <div>
         <NavbarTop/>
         <NavbarDown/>
        </div >
    )
}

export default Navigation;